import { flow, getParentOfType, getSnapshot } from 'mobx-state-tree';

import { PassolutionStore } from '../passolution';
import { LoadableStatus } from '../../mobx-utils';
import { ConditionsErrorResponse } from './utils';
import { BookingStore } from '../booking';

export const getEntryConditions = flow(function* (
  self,
  destinations,
  nat,
  orig,
  lng,
  date,
) {
  if (self.status === 'loading') return null;

  self.status = 'loading';

  const store = getParentOfType(self, PassolutionStore);

  const params = new URLSearchParams({ destinations, nat, orig, lng });

  if (date) params.set('date', date);

  const response = yield fetch(
    `api/${store.endpoints.entryConditions}?${params.toString()}`,
    {
      method: 'GET',
      credentials: 'include',
    },
  );

  const data = yield response.json();

  if (data?.statusCode && data?.statusCode === 429) {
    self.data = [
      {
        error: {
          code: data.statusCode,
          message: 'Too many requests',
        },
      },
    ];
  } else {
    self.data = data;
  }
  self.status = LoadableStatus.done;
});
